// File for logic corresponding to bookmark toggle component
import { Component } from 'js-component-framework';
import { addQueryArgs } from '@wordpress/url';
import apiFetch from '@wordpress/api-fetch';
import './index.scss';

/**
 * Component for bookmark toggle
 */
export default class BookmarkToggle extends Component {
  /**
   * Add action key.
   */
  addActionKey = 'add';

  /**
   * Add action key.
   */
  removeActionKey = 'remove';

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.initBookmarkToggle();
  }

  /**
   * Initialize bookmark toggle
   */
  initBookmarkToggle() {
    const bookmarkToggle = this.element;

    // Do nothing if there is no toggle.
    if (!bookmarkToggle) {
      return;
    }

    bookmarkToggle.addEventListener('click', () => {
      const isBookmarked = bookmarkToggle?.dataset?.bookmarked === 'true';
      const postId = bookmarkToggle?.dataset?.postId;
      const memberId = bookmarkToggle?.dataset?.memberId;

      // If article is bookmarked, remove it from user meta. Otherwise, add it.
      const path = addQueryArgs('/wp-json/cacm/v1/bookmark', {
        action: isBookmarked ? this.removeActionKey : this.addActionKey,
        postId,
        memberId,
      });

      apiFetch({ path }).then(({ status }) => {
        // Update the bookmark icon.
        if (status === 'ok') {
          bookmarkToggle.dataset.bookmarked = !isBookmarked;
        }
      });
    });
  }
}
